import React from "react";
import "./ConfirmTool.css";
import BackButtonText from "../Buttons/BackButtonText"

const Toolbar = (props) => {
  return (
    <div dir="rtl" className="toolbar">
      <nav className="toolbar_nav">
        <div>
            <BackButtonText text={"חזור"}/>
        </div>
        <div className="spacer" />
        <div className="toolbar_logo">
          <text>{props.textPage}</text>
        </div>
        <div className="spacer" />
        <div className="toolbar_nav_items">
          <ul></ul>
        </div>
      </nav>
    </div>
  );
};

export default Toolbar;
